import {
	Backdrop,
	ChildrenContainer,
	Container,
	ContentContainer,
	Link,
	PulsingLogo,
	ScrollingContainer,
	Subtitle,
	Title
} from './components'
import {PropsWithChildren} from 'react'
import {SUPPORT_URL} from '@/config/settings'
import {COLORS} from "@/components/common/Announcement/utils";
import {Button} from "@/components/common/Button";

interface AnnouncementProps extends PropsWithChildren {
	type?: keyof typeof COLORS
	modal?: boolean
	title?: string,
	priority?: number,
	subTitle?: string
}

const Announcement = ({
	                      type = 'error',
	                      modal = false,
	                      title = 'Error',
	                      priority = 0,
	                      subTitle = 'An error has occurred.',
	                      children,
                      }:AnnouncementProps) => {
	return (
		<Backdrop
			type={type}
			modal={modal}
			priority={priority}
		>
			<Container modal={modal}>
				<ScrollingContainer>
					<ContentContainer>
						<PulsingLogo type={type}/>
						{title && <Title>{title}</Title>}
						{subTitle && <Subtitle>{subTitle}</Subtitle>}
						<ChildrenContainer>
							{children || <>
								<Button
									primary
									onClick={() => (window.location.href = location.origin)}
								>
									{'Retry'}
								</Button>
								<Link
									href={SUPPORT_URL}
								>
									{'Get help'}
								</Link>
							</>}
						</ChildrenContainer>
					</ContentContainer>
				</ScrollingContainer>

			</Container>
		</Backdrop>
	)
}

export default Announcement